import { api } from "api/api";
import { AxiosError } from "axios";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ClassificacaoRequisitoService implements BaseServiceCadastros<ClassificacaoRequisito> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/classificacaoRequisito/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ClassificacaoRequisito>((resolve, reject): void => {
            api
                .get(`/classificacaoRequisito/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(classificacaoRequisito: ClassificacaoRequisito) {
        return new Promise<ClassificacaoRequisito>((resolve, reject): void => {
            api
                .post(`/classificacaoRequisito/incluir`, JSON.stringify(classificacaoRequisito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(classificacaoRequisito: ClassificacaoRequisito) {
        return new Promise<ClassificacaoRequisito>((resolve, reject): void => {
            api
                .put(`/classificacaoRequisito/editar`, JSON.stringify(classificacaoRequisito))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/classificacaoRequisito/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default ClassificacaoRequisitoService;
